import {User} from '@/domain/entities/User';
import authRepository from '@/domain/repository/AuthRepository';

export const getUsers = async (): Promise<Array<User> | undefined> => {
  try {
    return authRepository.users();
  } catch (error) {
    console.error('Error fetching users', error);
    return undefined;
  }
};